import { useState, useEffect } from 'react'
import { debug, info, warn, error } from '../../../utils/logger'
import { fetchAuthSession } from 'aws-amplify/auth'
import NetInfo from '@react-native-community/netinfo'
import {
    openDB,
    getAllPosts,
    getGlobalVersion,
    updateGlobalVersion,
    getAllLabels,
    addReaction,
    getAllReactions,
    deleteAllTablesPosts,
    getFavouritePosts,
    addPost,
} from '../../../db/indexDB'
import { apiUrl } from '../../../config/config'
import { PostsServices } from '../../../../database/posts.database'
import { usePostContext } from '../context/posts.context'

export const useFetchPosts = () => {
    const { setPostsContext, getPostsByLabel, postsContext, dataPosts, setDataPosts, updateViewPostsContext, getPostsFavourite } = usePostContext()
    const [posts, setPosts] = useState([])
    const [allResponse, setAllResponse] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const get_wall_version = async () => {
        if (isLoading) {
            console.log('⏭️ [POSTS] Already loading, skipping call')
            return
        }
        setIsLoading(true)
        try {
            const database = await openDB()
            const currentGlobalVersion = await getGlobalVersion(database, 'posts')
            console.log('📱 [POSTS] get_wall_version currentGlobalVersion', currentGlobalVersion)
            let data = {}
            const netInfoState = await NetInfo.fetch()
            let local_only = false
            let fetch_error = false
            if (netInfoState.isConnected && !local_only) {
                const session = await fetchAuthSession()
                const authToken = session.tokens.accessToken.toString()
                const response = await fetch(`${apiUrl}/get_wall`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        page: 0,
                        size: 200,
                        version: currentGlobalVersion,
                        //filter: selectedLabel ? selectedLabel : '',
                    },
                })

                if (!response.ok) {
                    console.error('❌ [POSTS] Failed to fetch posts', response?.status)
                    data = { status: 0 }
                    fetch_error = true
                }

                if (!fetch_error) {
                    data = await response.json()
                    console.log('📱 [POSTS] get_wall_version response status', data?.status)
                }
            } else {
                data = { status: 0 }
            }
            if (data.status === 1) {
                console.log('📱 [POSTS] status=1, updating local tables')
                // setAllResponse(data)
                // setDataPosts(data.single.data)
                // await deleteAllTablesPosts(database).then(() => {
                //     addAllPosts
                //     data.single.data.forEach(async (post, index) => {
                //         try {
                //             await addPost(database, post)

                //             //console.log('inserto==========>', index)
                //         } catch (error) {
                //             console.error('Error adding post:', error)
                //         }
                //     })

                //     data.single.reactions.forEach(async (reaction) => {
                //         try {
                //             await addReaction(database, reaction)
                //         } catch (error) {
                //             console.error('Error adding reaction:', error)
                //         }
                //     })
                // })
                await PostsServices.deleteAllTablesPosts().then(() => console.log('📱 [POSTS] deleted local tables at', new Date().toISOString()))

                // Añadir nuevos posts y reacciones
                let saveSuccess = false;
                try {
                    console.log('📱 [POSTS] Starting to add posts. Total posts:', data.single.data.length)
                    await PostsServices.addAllPosts(data.single.data);
                    console.log('✅ [POSTS] Successfully added all posts')
                    
                    console.log('📱 [POSTS] Starting to add reactions. Total reactions:', data.single.reactions.length)
                    for (const reaction of data.single.reactions) {
                        await PostsServices.addReaction(reaction);
                    }
                    console.log('✅ [POSTS] Successfully added all reactions')
                    saveSuccess = true;  // ✅ Solo marcar como exitoso si todo se guardó
                } catch (err) {
                    console.error('❌ [POSTS] Error al añadir posts o reacciones:', err)
                    console.error('Full error details:', err)
                    saveSuccess = false;  // ❌ Falló el guardado
                }
                
                // SOLO actualizar versión si se guardó exitosamente
                if (saveSuccess) {
                    let version_update = data.single.data_version
                    await updateGlobalVersion(database, 'posts', version_update)
                    console.log('✅ [POSTS] Version updated to', version_update)
                    
                    // CARGAR POSTS DESDE DB Y ACTUALIZAR CONTEXTO
                    console.log('📱 [POSTS] Loading posts from DB to context after save')
                    try {
                        const savedPosts = await PostsServices.getAllPosts(0, -1, null);  // pageSize=-1 para cargar TODOS
                        if (savedPosts && savedPosts.length > 0) {
                            setPostsContext(savedPosts);
                            console.log('✅ [POSTS] Context updated with', savedPosts.length, 'posts from DB')
                        } else {
                            console.warn('⚠️ [POSTS] No posts found in DB after save')
                        }
                    } catch (err) {
                        console.error('❌ [POSTS] Error loading posts to context:', err)
                    }
                } else {
                    console.error('❌ [POSTS] Posts NOT saved - version NOT updated - will retry on next login')
                }
            } else {
                // Status = 0: posts ya actualizados o sin conexión, cargar desde DB
                console.log('📱 [POSTS] Status != 1, loading existing posts from DB')
                try {
                    const savedPosts = await PostsServices.getAllPosts(0, -1, null);
                    if (savedPosts && savedPosts.length > 0) {
                        setPostsContext(savedPosts);
                        console.log('✅ [POSTS] Context loaded with', savedPosts.length, 'existing posts from DB')
                    } else {
                        console.warn('⚠️ [POSTS] No posts found in DB')
                    }
                } catch (err) {
                    console.error('❌ [POSTS] Error loading existing posts to context:', err)
                }
            }
        } catch (err) {
            console.error('❌ [POSTS] ERROR EN get_wall_version', err)
        } finally {
            setIsLoading(false)
        }
    }
    useEffect(() => {
        get_wall_version()
    }, [])

    return { allPosts: posts, allResponse: allResponse, get_wall_version: get_wall_version }
}
